import {BaseService} from './BaseService';
import {UriBuilder} from './UriBuilder';

export class PayPalService extends BaseService {
  private _merchantIdentifier: string = '';
  private orderId: any;

  constructor(apiUrl: string = '') {
    super();
    this.apiBaseUrl = `${apiUrl}/v2/order`;
  }

  async createPayPalOrder(currentOrder) {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('paypal')
      .path('create-order')
      .build();
    const result = await this.restClient.POST(url, [currentOrder], {'Content-type': 'application/json'});
    if (result.response) {
      let resultJson = await result.response;
      this.orderId = resultJson.id;
      return resultJson;
    }
    return this.throwAPIError(result.error);
  }

  async getClientId() {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('paypal')
      .path('client-id')
      .build();
    const result = await this.restClient.GET(url, {'Content-type': 'application/json'});
    if (result.response) {
      return await result.response;
    }
    return this.throwAPIError(result.error);
  }

  // Unneeded for now, cause this is done in the backend
  async capturePayPalOrder(): Promise<JSON> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('paypal' + this.orderId)
      .path(this.orderId)
      .path('capture-order' + this.orderId)
      .build();
    const result = await this.restClient.POST(url, []);
    if (result.response) {
      return await result.response.json();
    }
    return this.throwAPIError(result.error);
  }
}
